import Box from '@mui/material/Box';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  message: string;
  hint?: string;
  action?: ReactNode;
}

export function EmptyState({ message, hint, action }: EmptyStateProps) {
  return (
    <Box sx={{ py: 6, textAlign: 'center', color: 'text.secondary' }}>
      <InboxOutlinedIcon sx={{ fontSize: 44, opacity: 0.4 }} />
      <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: 600 }}>
        {message}
      </Typography>
      {hint ? (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {hint}
        </Typography>
      ) : null}
      {action ? <Box sx={{ mt: 2 }}>{action}</Box> : null}
    </Box>
  );
}
